module.exports = __webpack_public_path__ + "img/007.f9b3d86d.png";